// Shared fallback for any error surface (toast, inline, full-page) that ends up
// with no usable message — keeps the wording consistent instead of every call
// site inventing its own, and guarantees nothing blank or backend-raw is shown.
export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again.";
